<button type="button"
        [className]="'btn btn-secondary'"
        ngbTooltip="{{'submission.workflow.tasks.claimed.return_help' | translate}}"
        [disabled]="processing$ | async"
        (click)="submitTask()">
  <span *ngIf="processing$ | async"><span aria-hidden="true" class='fas fa-circle-notch fa-spin'></span> {{'submission.workflow.tasks.generic.processing' | translate}}</span>
  <span *ngIf="!(processing$ | async)"><span aria-hidden="true" class="fa fa-undo"></span> {{'submission.workflow.tasks.claimed.return' | translate}}</span>
</button>
